import clsx from 'clsx';
import {
  ShieldCheckIcon,
  ExclamationCircleIcon,
  InboxIcon,
  CheckCircleIcon,
} from '@heroicons/react/24/outline';

const variantConfig = {
  empty: {
    icon: InboxIcon,
    iconBg: 'bg-slate-100',
    iconColor: 'text-slate-500',
  },
  loading: {
    icon: null,
    iconBg: 'bg-slate-100',
    iconColor: 'text-slate-400',
  },
  error: {
    icon: ExclamationCircleIcon,
    iconBg: 'bg-red-100',
    iconColor: 'text-red-600',
  },
  success: {
    icon: CheckCircleIcon,
    iconBg: 'bg-emerald-100',
    iconColor: 'text-emerald-600',
  },
};

export default function EmptyState({
  variant = 'empty',
  icon: CustomIcon,
  title,
  description,
  action,
  className,
}) {
  const config = variantConfig[variant] || variantConfig.empty;
  const Icon = CustomIcon || config.icon;

  return (
    <div className={clsx('flex flex-col items-center justify-center py-16 text-center', className)}>
      {variant === 'loading' ? (
        <div className="w-16 h-16 mb-4 rounded-full bg-slate-100 flex items-center justify-center">
          <div className="w-8 h-8 border-3 border-slate-200 border-t-slate-500 rounded-full animate-spin" />
        </div>
      ) : Icon ? (
        <div className={clsx('w-16 h-16 mb-4 rounded-full flex items-center justify-center', config.iconBg)}>
          <Icon className={clsx('w-8 h-8', config.iconColor)} />
        </div>
      ) : null}

      {title && (
        <h3 className="text-lg font-semibold text-slate-700">{title}</h3>
      )}
      {description && (
        <p className="text-sm text-slate-500 mt-1 max-w-sm">{description}</p>
      )}
      {action && (
        <div className="mt-4">{action}</div>
      )}
    </div>
  );
}
